import React from "react";
import "./skills.css";

function Skills() {
  return (
    <section className="skills-section">
      <div className="skills-container">
        <h2 className="skills-title">Technical Skills</h2>

        <div className="skills-grid">
          {/* Programming Languages */}
          <div className="skills-category">
            <h3>Programming Languages</h3>
            <p>Java, JavaScript, C++, C#</p>
          </div>

          {/* Web Technologies */}
          <div className="skills-category">
            <h3>Web Technologies</h3>
            <p>HTML, CSS, React, Node.js</p>
          </div>

          {/* Frameworks and Libraries */}
          <div className="skills-category">
            <h3>Frameworks and Libraries</h3>
            <p>React</p>
          </div>

          {/* Databases */}
          <div className="skills-category">
            <h3>Databases</h3>
            <p>MySQL</p>
          </div>

          {/* Development Tools */}
          <div className="skills-category">
            <h3>Development Tools</h3>
            <p>VS, VS Code, Git, GitHub, SVN, Unity Engine</p>
          </div>

          {/* Operating Systems */}
          <div className="skills-category">
            <h3>Operating Systems</h3>
            <p>Windows</p>
          </div>

          {/* Other Technical Skills */}
          <div className="skills-category">
            <h3>Other Relevant Skills and Tools</h3>
            <p>Microsoft Office Suite, Trello, Google Suite</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Skills;